import { render } from "./ModalLoader.vue?vue&type=template&id=51f85c5e&scoped=true"
import script from "./ModalLoader.vue?vue&type=script&lang=js"
export * from "./ModalLoader.vue?vue&type=script&lang=js"

import "./ModalLoader.vue?vue&type=style&index=0&id=51f85c5e&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f85c5e"]])

export default __exports__